// extracted by mini-css-extract-plugin
export default {"baseClass":"end-note"};